var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.val,"color":_vm.color,"timeout":_vm.timeout},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('v-btn',{attrs:{"dark":"","text":"","icon":""},on:{"click":function($event){_vm.val = ''}}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdiClose))])],1)]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.val)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }